module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.3b813c2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Light.woff
// module id = 313
// module chunks = 1